import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" {...props}><path fill="currentColor" d="M9.36 6.854L14.682.676h-1.26L8.8 6.04 5.109.676H.852l5.581 8.111-5.581 6.479h1.26L6.994 9.6l3.898 5.665h4.257L9.36 6.854zM7.633 8.859l-.566-.808-4.5-6.427h1.938L8.136 6.81l.566.807 4.72 6.743h-1.937L7.633 8.859z" /></svg>);